import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  ListSubheader,
  Paper,
  InputBase,
  Divider,
  IconButton,
  Icon,
  Collapse,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    marginRight: 16,
  },
  input: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  dividerFullWidth: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
}));

export default function MbTextFieldSearch(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const { status, setStatus, setShowCheckBox, wfSteps, searchFnc, searchText } = props;

  return (
    <>
      <Paper component="div" className={classes.root}>
        <InputBase
          defaultValue={searchText}
          className={classes.input}
          placeholder="Search"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              searchFnc(e.target.value);
              e.preventDefault();
            }
          }}
          autoFocus
          inputProps={{ "aria-label": "search" }}
        />
        <IconButton
          type="submit"
          className={classes.iconButton}
          onClick={() => {
            searchFnc(searchText);
          }}
          aria-label="search"
        >
          <Icon>search</Icon>
        </IconButton>
        <Divider className={classes.divider} orientation="vertical" />
        <IconButton
          className={classes.iconButton}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <Icon>filter_list</Icon>
        </IconButton>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Divider className={classes.dividerFullWidth} />
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ margin: "0 0 10px 16px" }}>
              <FormControl variant="outlined">
                <InputLabel id="status">Status</InputLabel>
                <Select
                  variant="outlined"
                  margin="dense"
                  labelId="status"
                  label="Status"
                  value={status}
                  onChange={(e) => {
                    var showc = wfSteps?.find((item) => item.StepNo === parseInt(e.target.value));
                    if (showc && wfSteps) {
                      setShowCheckBox(true);
                    } else {
                      setShowCheckBox(false);
                    }
                    setStatus(e.target.value);
                  }}
                  style={{ width: 160 }}
                >
                  <MenuItem key={"All"} value={"All"}>
                    All
                  </MenuItem>
                  {/* {wfSteps && (
                    <MenuItem key={"0"} value={"0"}>
                      Revise
                    </MenuItem>
                  )} */}
                  <MenuItem key={"E"} value={"E"}>
                    Effective
                  </MenuItem>
                  <MenuItem key={"V"} value={"V"}>
                    Void
                  </MenuItem>
                  {wfSteps && wfSteps?.length > 0 && (
                    <div>
                      <Divider />
                      <ListSubheader>Workflow Step</ListSubheader>
                    </div>
                  )}
                  {wfSteps && (
                    <MenuItem key={"InProcess"} value={"InProcess"}>
                      In Process
                    </MenuItem>
                  )}
                  {wfSteps &&
                    wfSteps.map((item, idx) => (
                      <MenuItem key={idx} value={item.StepNo.toString()}>
                        {item.StepName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Collapse>
      </Paper>
    </>
  );
}
